import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import useStyles from './styles';
import Tab from '../AppBarWithTabs/Tab';
import ActionListContent from './ActionListContent';
import {
  userPreferencesState,
  currentViewNameState,
} from '../HomePage/TicketList/TicketListSlice';

function ActionListPage() {
  const classes = useStyles();
  const selectedTab = useSelector(currentViewNameState);
  const userPreferences = useSelector(userPreferencesState);
  const [tabs, setTabs] = useState(userPreferences);

  useEffect(() => {
    setTabs(userPreferences);
  }, [selectedTab]);

  return (
    <div className={classes.root}>
      {tabs.map((view, index) => {
        const key = `table-key-${index}`;
        return (
          <Tab selectedTab={selectedTab} index={view.viewName} key={key}>
            <ActionListContent />
          </Tab>
        );
      })}
    </div>
  );
}
export default ActionListPage;
